import { HttpClient } from '../../httpClient'
import type { OpalApi } from '../../schema'

export const createWorkflowAssignment: OpalApi<
  'CreateWorkflowAssignmentV3',
  201
> = async ({
  requestBody,
}: Parameters<OpalApi<'CreateWorkflowAssignmentV3', 201>>[0] = {}) => {
  const url = new URL('/v3/workflow_assignments', window.location.origin)
  return HttpClient()
    .post(url.toString(), requestBody)
    .then((res) => res.data)
}
